import React from 'react';

const Test = () => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Test Page</h1>
          <p className="text-gray-600">This is a test page for development and testing purposes.</p>
        </div>
      </div>

      {/* Content Card */}
      <div className="card">
        <div className="p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Welcome to the Test Page</h2>
          <p className="text-gray-600">
            This page can be used for testing new features, components, or functionality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Test;

